import glamorous from "glamorous";

export const Container = glamorous.div({
  listStyle: "none",
  paddingTop: "20px",
  paddingLeft: "20px",
  paddingRight: "20px",
  paddingBottom: "30px",
  height: "auto",
  backgroundColor: "rgb(255, 255, 255)",
  "@media screen and (min-width: 1025px)": {
    paddingTop: "30px",
    paddingLeft: "60px",
    paddingRight: "60px",
  },
});

export const Title = glamorous.h2({
  color: "rgb(25, 25, 25) !important",
  fontSize: "30px",
  fontFamily: "jd_sans_probold",
  fontWeight: "1.2",
  display: "block",
  margin: "0px",
  lineHeight: "1.2",
  cursor: "default",
  textAlign: "center",
});

export const Description = glamorous.p({
  cursor: "default",
});

export const Label = glamorous.div({
  textAlign: "left",
});

export const SearchDropdown = glamorous.div(
  {
    position: "relative",
    paddingLeft: "0px",
    marginLeft: "0px",
    marginRight: "23px",
    color: "rgb(51, 51, 51)",
    fontSize: "18px",
    textDecoration: "none",
    boxSizing: "border-box",
    display: "inline-block",
    cursor: "pointer",
    overflow: "visible",
    height: "42px",
    width: "100%",
    backgroundColor: "rgb(255, 255, 255)",
  },
  ({ isOpen }) => ({
    border: isOpen === true ? "1px solid rgb(102, 102, 102)" : "1px solid rgb(194, 194, 194)",
  })
);

export const PublicationSpan = glamorous.span(
  {
    width: "calc(100% - 34px)",
    fontFamily: "jd_sans_promedium",
    fontSize: "18px",
    verticalAlign: "middle",
    paddingLeft: "12px",
    lineHeight: "41px",
    textDecoration: "none",
    boxSizing: "border-box",
    display: "inline-block",
    textAlign: "left",
  },
  ({ isOpen }) => ({
    color: isOpen === true ? "rgb(51, 51, 51)" : "rgb(102, 102, 102)",
  })
);

export const CarrotDropdown = glamorous.span(
  {
    verticalAlign: "middle",
    fontSize: "14px",
    padding: "10px",
    paddingTop: "13px",
    paddingBottom: "13px",
    color: "rgb(102, 102, 102)",
    top: "7px",
    right: "0",
    fontFamily: "jd_icon !important",
    speak: "none",
    marginLeft: "auto",
    marginRight: "auto",
    fontStyle: "normal",
    fontWeight: "400",
    fontVariant: "none",
    lineHeight: "1",
    boxSizing: "border-box",
    textDecoration: "none",
    boxSize: "border-box",
    display: "inline-block",
  },
  ({ isOpen }) => ({
    ":before": {
      content: isOpen === true ? "\\E904" : "\\E901",
      color: isOpen === true ? "rgb(51, 51, 51)" : "rgb(102, 102, 102)",
    },
  })
);

export const SearchDropdownUL = glamorous.ul(
  {
    position: "absolute",
    border: "1px solid rgb(102, 102, 102)",
    top: "22px",
    display: "block",
    boxSizing: "border-box",
    marginLeft: "-1px",
    background: "rgb(255, 255, 255)",
    padding: 0,
    align: "right",
    cursor: "default",
    zIndex: 2000,
    width: "calc(100% + 2px)",
  },
  ({ isOpen }) => ({
    height: isOpen === true ? "auto" : "0",
    border: isOpen === true ? "1px solid rgb(102, 102, 102)" : "0px solid rgb(102, 102, 102)",
  })
);

export const SearchDropdownLI = glamorous.li(
  {
    paddingLeft: "30px",
    position: "relative",
    textAlign: "left",
    boxSizing: "border-box",
    fontFamily: "jd_sans_promedium",
    listStyle: "none",
    cursor: "pointer",
    zIndex: 2000,
    ":hover": {
      color: "rgb(51, 51, 51)",
    },
  },
  ({ isOpen }) => ({
    visibility: isOpen === true ? "show" : "hidden",
  }),
  ({ isFirstChild }) => ({
    marginTop: isFirstChild === true ? "20px" : "8px",
  }),
  ({ isLastChild }) => ({
    marginBottom: isLastChild === true ? "20px" : "8px",
  }),
  ({ isActive }) => ({
    color: isActive === true ? "rgb(51, 51, 51)" : "rgb(102, 102, 102)",
  })
);

export const ButtonBox = glamorous.div({
  boxSizing: "border-box",
  display: "inline-block",
  width: "100%",
  textAlign: "center",
  marginTop: "20px",
  marginBottom: "0px",
  marginLeft: "0px",
  marginRight: "0px",
  "@media screen and (min-width: 1025px)": {
    marginLeft: "0px",
    marginRight: "0px",
    width: "100%",
  },
});

export const SubscriptionBoxLeft = glamorous.div({
  marginTop: "30px",
  width: "100%",
  display: "block",
  "@media screen and (min-width: 1025px)": {
    width: "calc(50% - 10px)",
    display: "inline-block",
    marginRight: "10px",
  },
});

export const SubscriptionBoxRight = glamorous.div({
  marginTop: "30px",
  width: "100%",
  display: "block",
  "@media screen and (min-width: 1025px)": {
    width: "calc(50% - 10px)",
    display: "inline-block",
    marginLeft: "10px",
  },
});

export const SubscriptionHeader = glamorous.div({
  backgroundColor: "rgb(229, 230, 230)",
  padding: "8px",
  paddingLeft: "14px",
  fontFamily: "jd_sans_prosemibold",
  borderBottom: "1px solid rgb(194, 194, 194)",
  "@media screen and (min-width: 1025px)": {},
});

export const SubscriptionSelections = glamorous.div({
  "@media screen and (min-width: 1025px)": {},
});

export const Selection = glamorous.div({
  padding: "8px",
  paddingLeft: "14px",
  borderLeft: "1px solid rgb(194, 194, 194)",
  borderRight: "1px solid rgb(194, 194, 194)",
  borderBottom: "1px solid rgb(194, 194, 194)",
  cursor: "pointer",
  color: "rgb(54, 124, 43)",
  ":hover": {
    color: "rgb(51, 51, 51)",
    backgroundColor: "rgb(239, 240, 240)",
  },
});
